import type { FC } from 'react'
import { Trans } from 'react-i18next'

import { TypographyText } from '~/core/ui/Text'
import { cn } from '~/core/ui/utils'
import { isHTML } from '~/core/utilities/common'
import { defaultFormatDate } from '~/core/utilities/format-date'

import type { INotification, INotificationTask } from '~/lib/features/notifications/types'
import useBoundStore from '~/lib/store'

import HTMLDisplay from '~/components/HTMLDisplay'

import NotificationItemLayout from './NotificationItemLayout'

const OverdueDateTask: FC<{
  notification: INotification
  onClick: () => void
  onDelete: () => void
  isLoadingDeleted: boolean
}> = ({ notification, onClick, onDelete, isLoadingDeleted }) => {
  const { setOpenTaskDrawer } = useBoundStore()
  const propertiesRelated = notification?.payload as INotificationTask

  return (
    <NotificationItemLayout
      onDelete={onDelete}
      isLoadingDeleted={isLoadingDeleted}
      user={notification.recipient}
      actionType={notification.actionType}
      readAt={notification.readAt}
      createdAt={notification.createdAt}>
      {({ time }) => (
        <>
          <TypographyText
            className="cursor-pointer text-sm text-gray-700"
            onClick={() => {
              setOpenTaskDrawer(true)
              onClick && onClick()
            }}>
            {propertiesRelated?.applicantId ? (
              <Trans
                i18nKey="activity:notification:overdueDateApplicationTask"
                values={{
                  userName: notification?.user?.fullName,
                  profileFullName: propertiesRelated.profileFullName,
                  timeFormatted: propertiesRelated.taskDueDate
                    ? defaultFormatDate(new Date(propertiesRelated.taskDueDate))
                    : ''
                }}>
                <span className="font-medium text-gray-900" />
              </Trans>
            ) : propertiesRelated?.companyName ? (
              <Trans
                i18nKey="activity:notification:overdueDateCompanyTask"
                values={{
                  userName: notification?.user?.fullName,
                  companyName: propertiesRelated.companyName,
                  timeFormatted: propertiesRelated.taskDueDate
                    ? defaultFormatDate(new Date(propertiesRelated.taskDueDate))
                    : ''
                }}>
                <span className="font-medium text-gray-900" />
              </Trans>
            ) : (
              <Trans
                i18nKey="activity:notification:overdueDateTask"
                values={{
                  userName: notification?.user?.fullName,
                  timeFormatted: propertiesRelated.taskDueDate
                    ? defaultFormatDate(new Date(propertiesRelated.taskDueDate))
                    : ''
                }}>
                <span className="font-medium text-gray-900" />
              </Trans>
            )}
            {time}
          </TypographyText>

          {propertiesRelated?.taskTitle ? (
            <div
              className={cn(
                'rounded-xs mt-1.5 border border-gray-100 bg-gray-50 px-1.5 pt-3',
                isHTML(propertiesRelated.taskTitle) ? 'pb-1.5' : 'pb-3'
              )}>
              <HTMLDisplay
                content={propertiesRelated.taskTitle}
                className="line-clamp-2 text-xs text-gray-900"
              />
            </div>
          ) : null}
        </>
      )}
    </NotificationItemLayout>
  )
}

export default OverdueDateTask
